import type { CustomDrink, Pagination } from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'custom-drinks';

export function getCustomDrinks(query: CustomDrink.SearchQuery) {
    return api.get<Pagination<CustomDrink>>(rootPath, query);
}

export function getCustomDrink(id: number) {
    return api.get<CustomDrink.DetailsResponse>(`${rootPath}/${id}`, undefined);
}

export function postCustomDrink(data: CustomDrink.CreateRequest) {
    return api.post<CustomDrink>(rootPath, data);
}

export function putCustomDrink(id: number, data: CustomDrink.UpdateRequest) {
    return api.put<CustomDrink>(`${rootPath}/${id}`, data);
}

export function deleteCustomDrink({ id }: CustomDrink.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
